var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.detail)?_c('div',{staticClass:"esg-page cms-content"},[(_vm.detail.description_pb)?_c('div',{staticClass:"_pageBuilderFrame_content",attrs:{"id":"pb-content"},domProps:{"innerHTML":_vm._s(_vm.$fixPbContentBefore(_vm.detail.description_pb))}}):_vm._e()]):(_vm.displayContent==='404')?_c('missing'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }